(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/tables/assets/javascripts/models/statgeneraltables.js') >= 0) return;  svs.modules.push('/components/statistics/tables/assets/javascripts/models/statgeneraltables.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.models = svs.statistics.models || {}; 

  var TableModel = _.extend({}, svs.statistics.mixins.SocketSubscriber, {
    logger: new svs.core.log.Logger('svs.statistics.model.StatGeneralTables'),
    noLiveCoverage: false,
    url: function url() {
      if (this.get('leagueIds')) {
        return svs.core.jupiter.url() + this.makeMultifetch(this.get('leagueIds'), this.urlArguments());
      } else if (this.get('leagueId')) {
        return "".concat(svs.core.jupiter.url(), "/sport/1/leagues/").concat(this.currentLeagueId, "/leaguetable?").concat(this.urlArguments());
      }

      return false;
    },
    socketResourcePath: function socketResourcePath() {
      return "/sport/1/leagues/".concat(this.currentLeagueId, "/leaguetable?type=Live&round=0");
    },
    liveMatchesByLeague: [],
    initialize: function initialize() {
      if (this.liveMatchesByLeague.length > 0) {
        this.liveMatchesByLeague.length = 0;
      }

      if (!this.get('preloaded')) {
        this.set('preloaded', 'leagueModels');
      }

      var preloaded = this.get('preloaded');

      if (this.get('leagueIds')) {
        this.currentLeagueId = this.get('leagueId');

        if (svs.utils.ns.isNamespace("statistics.data.".concat(preloaded, ".leaguetables"), svs)) {
          this.parse(svs.statistics.data[preloaded].leaguetables);
        } else if (this.get('leagueTables')) {
          this.parse(this.get('leagueTables'));
        }
      } else if (this.get('leagueId')) {
        this.currentLeagueId = this.get('leagueId');

        if (svs.utils.ns.isNamespace("statistics.data.".concat(preloaded, ".leaguetables"), svs)) {
          this.parse(svs.statistics.data[preloaded].leaguetables);
        } 


        if (this.get('league')) {
          this.underlyingLeagues = this.sortLeagues();

          if (this.underlyingLeagues) {
            this.underlyingLeagues = _.filter(this.underlyingLeagues, function (league) {
              return !league.isMultiTier;
            });

            if (this.underlyingLeagues[0]) {
              this.currentLeagueId = this.underlyingLeagues[0].id;
            }
          }
        }
      } else if (this.get('leagueTables')) {
        this.parse(this.get('leagueTables'));
      }

      this.set('selection', 'Normal');
    },
    sortLeagues: function sortLeagues() {
      this.underlyingLeagues = this.get('league').underlyingLeagues;

      if (this.underlyingLeagues) {
        this.underlyingLeagues.sort(function (a, b) {
          var nameA = a.name.toUpperCase(); 

          var nameB = b.name.toUpperCase(); 

          if (nameA < nameB) {
            return -1;
          }

          if (nameA > nameB) {
            return 1;
          } 


          return 0;
        });
      }

      return this.underlyingLeagues;
    },
    doFetch: function doFetch() {
      var _self = this;

      this.fetch({
        error: function error(model, xhr) {
          _self.set({
            leagueTables: null
          });

          if (!xhr.responseJSON || xhr.responseJSON && xhr.responseJSON.error && xhr.responseJSON.error.code !== 404) {
            _self.trigger('fetchError');
          } else {
            _self.trigger('change', _self);
          }
        }
      });
    },
    parse: function parse(response) {
      if (response.error) {
        this.set(response);
        return response;
      }

      var leagueTypes = ['total', 'home', 'away'];
      var leagueTables = []; 

      if (response.responses) {
        response.leagueTables = [];

        _.each(response.responses, function (resp) {
          if (resp.leagueTable) {
            if (Array.isArray(leagueTables)) {
              response.leagueTables = response.leagueTables.concat(resp.leagueTable);
            } else {
              response.leagueTables.push(resp.leagueTable);
            }
          } else if (resp.result) {
            var table = response.leagueTables[response.leagueTables.length - 1];

            if (table) {
              table.liveMatches = [];

              _.each(resp.result, function (result) {
                var match = result.payload.match;

                if (match.league.id === table.league.id) {
                  table.liveMatches.push(match);
                }
              });
            }
          }
        });
      } 


      if (response.leagueTables) {
        leagueTables = response.leagueTables; 
      } else if (response.leagueTable) {
        leagueTables = response.leagueTable;
        delete response.leagueTable;
      } 


      if (!Array.isArray(leagueTables)) {
        leagueTables = [leagueTables];
      } 


      for (var i = 0; i < leagueTables.length; i++) {
        for (var tableRow in leagueTables[i].tableRows) {
          if (Object.prototype.hasOwnProperty.call(leagueTables[i].tableRows, tableRow)) {
            for (var type in leagueTypes) {
              if (Object.prototype.hasOwnProperty.call(leagueTypes, type)) {
                if (leagueTables[i].tableRows[tableRow][leagueTypes[type]].winOverTime && leagueTables[i].tableRows[tableRow][leagueTypes[type]].winPenalty) {
                  leagueTables[i].tableRows[tableRow][leagueTypes[type]].winOverTimeOrPenalty = parseInt(leagueTables[i].tableRows[tableRow][leagueTypes[type]].winOverTime, 10) + parseInt(leagueTables[i].tableRows[tableRow][leagueTypes[type]].winPenalty, 10);
                  leagueTables[i].tableRows[tableRow][leagueTypes[type]].winFullTime = leagueTables[i].tableRows[tableRow][leagueTypes[type]].win - leagueTables[i].tableRows[tableRow][leagueTypes[type]].winOverTimeOrPenalty;
                } else {
                  leagueTables[i].tableRows[tableRow][leagueTypes[type]].winFullTime = leagueTables[i].tableRows[tableRow][leagueTypes[type]].win;
                }

                if (leagueTables[i].tableRows[tableRow][leagueTypes[type]].lossOverTime && leagueTables[i].tableRows[tableRow][leagueTypes[type]].lossPenalty) {
                  leagueTables[i].tableRows[tableRow][leagueTypes[type]].lossOverTimeOrPenalty = parseInt(leagueTables[i].tableRows[tableRow][leagueTypes[type]].lossOverTime, 10) + parseInt(leagueTables[i].tableRows[tableRow][leagueTypes[type]].lossPenalty, 10);
                  leagueTables[i].tableRows[tableRow][leagueTypes[type]].lossFullTime = leagueTables[i].tableRows[tableRow][leagueTypes[type]].loss - leagueTables[i].tableRows[tableRow][leagueTypes[type]].lossOverTimeOrPenalty;
                } else {
                  leagueTables[i].tableRows[tableRow][leagueTypes[type]].lossFullTime = leagueTables[i].tableRows[tableRow][leagueTypes[type]].loss;
                }
              }
            }
          }
        }
      }

      response.leagueTables = leagueTables;
      this.set(response); 

      this.onMatchStatusChange();
      return response;
    },
    urlArguments: function urlArguments() {
      return "type=".concat(this.get('selection'));
    },
    setSelection: function setSelection(selection) {
      this.set('selection', selection);
      this.doFetch();
    },
    setCurrentLeague: function setCurrentLeague(leagueId) {
      this.currentLeagueId = leagueId;
      this.doFetch();
    },
    makeMultifetch: function makeMultifetch(idList, urlArgument) {
      var path = '/multifetch?urls=';

      _.each(idList, function (id) {
        path += "".concat(encodeURIComponent("/sport/1/leagues/".concat(id, "/leaguetable?").concat(urlArgument)), "|");
      }); 


      path = path.substring(0, path.length - 1);
      return path;
    },
    onSocketUpdate: function onSocketUpdate(param) {
      if (svs.statistics && svs.statistics.socketCache) {
        svs.statistics.socketCache.add('LEAGUE', param.match);
      }

      if (_.isObject(param)) {
        this.parse(param);
      } else {
        this.logger.debug('No live table availiable', param);
        this.noLiveCoverage = true;
        this.unsubscribe(this.socketResourcePath(), this);
        this.trigger('isLiveTable');
        this.doFetch();
      }
    },
    onLiveMatchesFetched: function onLiveMatchesFetched() {
      var currentLeague = this.getCurrentLeagueTable(),
          liveMatches = currentLeague ? this.getLiveMatchesByLeagueId(currentLeague.leagueId) : undefined;

      if (liveMatches) {
        liveMatches.leagueId = this.get('leagueId');
      }

      if (this.isLiveTable()) {
        this.subscribe(this.socketResourcePath(), this.onSocketUpdate, true);

        if (liveMatches) {
          this.listenTo(liveMatches.liveMatches, 'change:status', this.onMatchStatusChange);
        }

        this.trigger('isLiveTable');
      } 


      this.onMatchStatusChange();
    },
    isLiveTable: function isLiveTable() {
      var currentLeague = this.getCurrentLeagueTable(),
          liveMatches = currentLeague ? this.getLiveMatchesByLeagueId(currentLeague.leagueId) : undefined;

      if (this.noLiveCoverage) {
        return false;
      }

      if (window.location.href.indexOf('isMocked') > -1) {
        return true;
      }

      if (liveMatches) {
        return liveMatches.hasLiveMatches();
      }

      return false;
    },
    onMatchStatusChange: function onMatchStatusChange(e) {
      this.logger.debug('onMatchStatusChange', e); 

      var currentLeague = this.getCurrentLeagueTable(),
          liveMatches = currentLeague ? this.getLiveMatchesByLeagueId(currentLeague.leagueId) : undefined,
          liveTeams = svs.utils.ns.isNamespace('getLiveTeams', liveMatches) ? liveMatches.getLiveTeams() : [],
          self = this;

      if (currentLeague) {
        _.each(currentLeague.tableRows, function (row) {
          var liveTeam = _.find(liveTeams, function (teamId) {
            return teamId === row.teamId;
          });

          row.isLive = liveTeam !== undefined;

          if (row.isLive) {
            self.logger.debug('isLive', row.rowData);
          }
        });

        this.trigger('change');
      }
    },
    getCurrentLeagueTable: function getCurrentLeagueTable() {
      var self = this;

      if (self.currentLeagueId) {
        return _.find(this.get('leagueTables'), function (leagueTable) {
          return leagueTable.league.id === self.currentLeagueId;
        });
      }

      return this.get('leagueTables')[0];
    },
    getLiveMatchesByLeagueId: function getLiveMatchesByLeagueId(leagueId) {
      for (var i = 0; i < this.liveMatchesByLeague.length; i++) {
        if (this.liveMatchesByLeague[i].leagueId === leagueId) {
          return this.liveMatchesByLeague[i].liveMatches;
        }
      }

      return undefined;
    },
    isInLiveMatches: function isInLiveMatches(leagueId) {
      for (var i = 0; i < this.liveMatchesByLeague.length; i++) {
        if (this.liveMatchesByLeague[i].leagueId === leagueId) {
          return true;
        }
      }

      return false;
    },
    destroy: function destroy() {
      for (var i = 0; i < this.liveMatchesByLeague.length; i++) {
        if (svs.utils.ns.isNamespace('liveMatches', this.liveMatchesByLeague[i])) {
          this.liveMatchesByLeague[i].liveMatches.off();
          this.liveMatchesByLeague[i].liveMatches.reset();
          this.liveMatchesByLeague[i].liveMatches = undefined;
        }
      }
    }
  });

  svs.statistics.models.StatGeneralTables = Backbone.Model.extend(TableModel);
})(Backbone, _, svs);
 })(window);